export interface IPaymentService {
    processPayment(paymentRequest: PaymentRequest): Promise<PaymentResult>;

    verifyPayment(transactionId: string): Promise<PaymentVerification>;

    refundPayment(transactionId: string, amount?: number): Promise<RefundResult>;

    calculatePaymentPlan(
        amount: number,
        frequency: PaymentFrequency,
        duration: number
    ): PaymentPlanCalculation;

    getPaymentMethods(): Promise<PaymentMethod[]>;
}

export interface PaymentRequest {
    orderId: string;
    amount: number;
    currency: string;
    paymentMethodId: string;
    description?: string;
    metadata?: Record<string, any>;
}

export interface PaymentResult {
    transactionId: string;
    status: PaymentStatus;
    amount: number;
    currency: string;
    paymentMethod: string;
    redirectUrl?: string;
    metadata?: Record<string, any>;
}

export interface PaymentVerification {
    transactionId: string;
    status: PaymentStatus;
    amount: number;
    paidAt?: Date;
}

export interface RefundResult {
    refundId: string;
    transactionId: string;
    amount: number;
    status: RefundStatus;
}

export interface PaymentPlanCalculation {
    totalAmount: number;
    installments: PaymentInstallment[];
    frequency: PaymentFrequency;
    duration: number;
}

export interface PaymentInstallment {
    amount: number;
    dueDate: Date;
    installmentNumber: number;
}

export interface PaymentMethod {
    id: string;
    name: string;
    type: PaymentMethodType;
    enabled: boolean;
    fees?: PaymentFee[];
}

export interface PaymentFee {
    type: FeeType;
    amount: number;
    percentage?: number;
}

export enum PaymentStatus {
    PENDING = 'pending',
    PROCESSING = 'processing',
    COMPLETED = 'completed',
    FAILED = 'failed',
    CANCELLED = 'cancelled'
}

export enum RefundStatus {
    PENDING = 'pending',
    COMPLETED = 'completed',
    FAILED = 'failed'
}

export enum PaymentFrequency {
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly'
}

export enum PaymentMethodType {
    MOBILE_MONEY = 'mobile_money',
    BANK_CARD = 'bank_card',
    BANK_TRANSFER = 'bank_transfer',
    CRYPTO = 'crypto'
}

export enum FeeType {
    FIXED = 'fixed',
    PERCENTAGE = 'percentage'
}